<script setup lang="ts">
import type { Schemas } from '#shopware'
import { getCategoryRoute } from '@shopware/helpers'

defineProps<{
    categories: NonNullable<Schemas['HeroSlide']['categories']>
}>()
</script>

<template>
    <div
        class="grid max-w-[640px] mx-auto px-4 sm:px-0 gap-3 mt-3"
        :class="{
            'grid-cols-1': categories.length === 1,
            'grid-rows-1 grid-cols-2': categories.length === 2,
            'grid-rows-2 md:grid-rows-1 grid-cols-2 md:grid-cols-3': categories.length === 3,
            'grid-rows-3 md:grid-rows-2 grid-cols-2 md:grid-cols-3': categories.length >= 5,
            'grid-rows-2 grid-cols-2' : categories.length === 4,
        }"
    >
        <div v-for="(cat, index) in categories" :key="index">
            <MiscLink
                :to="getCategoryRoute(cat)"
                class="btn slide-button btn-md text-base-100 w-full btn-outline border-sale-content rounded-xs"
            >
                {{ cat.translated?.name }}
            </MiscLink>
        </div>
    </div>
</template>